import { useNavigate } from 'react-router-dom';
import { X, Check } from 'lucide-react';
import { Button } from './ui/button';

export default function UpgradeModal(props) {
  const { title, description, ctaText = 'Upgrade Now', onClose } = props;
  const benefits = props.benefits || [];
  const navigate = useNavigate();

  const handleCTA = () => {
    onClose();
    navigate('/upgrade');
  };

  return (
    <div
      className="fixed inset-0 bg-black/85 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-card border border-border/60 max-w-md w-full mx-4 relative overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Amber gradient top bar */}
        <div
          className="h-1 w-full"
          style={{ background: 'linear-gradient(90deg, #C47A0A 0%, #E8A020 35%, #F5C842 65%, #E8A020 100%)' }}
        />

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          data-testid="upgrade-modal-close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="p-8">
          {/* Wordmark */}
          <div
            className="font-mono text-xs uppercase tracking-widest mb-6"
            style={{ color: '#E8A020' }}
          >
            PANGAJI
          </div>

          {/* Headline */}
          <h2 className="font-mono text-2xl font-bold text-foreground leading-tight mb-3">
            {title}
          </h2>

          {/* Description */}
          <p className="text-sm text-muted-foreground font-mono mb-6 leading-relaxed">
            {description}
          </p>

          {/* Benefits */}
          {benefits.length > 0 && (
            <ul className="mb-8 space-y-2.5">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check
                    className="w-4 h-4 mt-0.5 shrink-0"
                    style={{ color: '#E8A020' }}
                  />
                  <span className="text-sm font-mono text-foreground/90">{benefit}</span>
                </li>
              ))}
            </ul>
          )}

          {/* CTA */}
          <Button
            onClick={handleCTA}
            className="w-full rounded-none font-mono uppercase tracking-widest text-sm text-black font-bold h-12"
            style={{ background: 'linear-gradient(90deg, #C47A0A 0%, #E8A020 50%, #C47A0A 100%)' }}
            data-testid="upgrade-modal-cta"
          >
            {ctaText}
          </Button>

          {/* Dismiss link */}
          <button
            onClick={onClose}
            className="mt-4 w-full text-center text-xs font-mono text-muted-foreground hover:text-foreground transition-colors uppercase tracking-widest"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
